import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useAppSelector } from '@/redux/hooks';
import { getItemSummaryCatalogId, getItemSummarySellerId } from '@/redux/modules/item/summary/itemSummary.selectors';

import { AuctioneerInfo } from './components/AuctioneerInfo/AuctioneerInfo';
import { CuratorInfo } from './components/CuratorInfo/CuratorInfo';
import { ItemDescription } from './components/ItemDescription/ItemDescription';

type Props = {
    className?: string;
    itemId: number;
};

export const CurrentItemDetails = ({ className, itemId }: Props) => {
    const catalogId = useAppSelector((state) => getItemSummaryCatalogId(state, itemId));
    const sellerId = useAppSelector((state) => getItemSummarySellerId(state, itemId));

    return (
        <section className={cn('relative flex flex-col', className)}>
            <ItemDescription
                className="mt-0 border-t-0 pt-0"
                itemId={itemId}
            />
            <AuctioneerInfo
                itemId={itemId}
                sellerId={sellerId}
            />
            <CuratorInfo catalogId={catalogId} />
        </section>
    );
};
